import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import { LoginSelector } from "store/auth/login/selectors";

const useAuthorized = () => {
  const [isAuthorized, setIsAuthorized] = useState(true);
  const { user } = useSelector(LoginSelector);
  const history = useHistory();

  const checkUser = useCallback(() => {
    if (!localStorage.getItem("b2c:authUser")) {
      setIsAuthorized(false);
    }
  }, []);

  useEffect(() => {
    if (!isAuthorized) {
      localStorage.clear();
      history.push("/login");
    }
  }, [isAuthorized]);

  useEffect(() => {
    if (user) {
      setIsAuthorized(true);
    }
    history.listen(() => {
      checkUser();
    });
  }, [history, user]);

  useEffect(() => {
    checkUser();
  }, []);

  return [isAuthorized];
};

export default useAuthorized;
